(() => {
  const namespaceKey = 'GuruShopMinGuruSessionStatus';
  const markerSelector = 'script[data-min-guru-session-root]';
  const accountSelector = '[data-min-guru-account]';
  const accountShellSelector = '[data-min-guru-account-shell]';
  const accountMenuSelector = '[data-min-guru-account-menu]';
  const existingApi = window[namespaceKey];

  if (existingApi?.initById) {
    document.querySelectorAll(markerSelector).forEach((marker) => {
      existingApi.initById(marker.dataset.minGuruSessionRoot);
    });
    return;
  }

  const rootBindings = new WeakMap();
  const requestByEndpoint = new Map();

  const sessionEndpoint = (accountLink) => {
    try {
      const endpoint = new URL(accountLink.href);
      endpoint.pathname = '/min-guru/api/session';
      endpoint.search = '';
      endpoint.hash = '';
      return endpoint.toString();
    } catch {
      return null;
    }
  };

  const readSession = (endpoint) => {
    if (!requestByEndpoint.has(endpoint)) {
      const request = fetch(endpoint, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
        method: 'GET',
      })
        .then((response) => (response.ok ? response.json() : { authenticated: false }))
        .catch(() => ({ authenticated: false }));

      requestByEndpoint.set(endpoint, request);
    }

    return requestByEndpoint.get(endpoint);
  };

  const applySession = (accountLink, session) => {
    if (!session?.authenticated || typeof session.firstName !== 'string') return;

    const firstName = session.firstName.trim().slice(0, 60);
    if (!firstName) return;

    const accountShell = accountLink.closest(accountShellSelector);
    const accountMenu = accountShell?.querySelector(accountMenuSelector);
    const accountTrigger = accountShell?.querySelector('[data-min-guru-account-trigger]');

    accountLink.dataset.minGuruAuthenticated = 'true';
    accountShell?.setAttribute('data-min-guru-authenticated', 'true');
    accountLink.setAttribute('aria-label', `Åbn Min Guru for ${firstName}`);
    accountShell?.querySelectorAll('[data-min-guru-account-label]').forEach((label) => {
      label.textContent = `Hej, ${firstName}`;
    });

    if (accountMenu instanceof HTMLDetailsElement) {
      accountLink.hidden = true;
      accountMenu.hidden = false;
      accountTrigger?.setAttribute('aria-label', `Åbn konto-menu for ${firstName}`);
    }
  };

  const initRoot = (sectionRoot) => {
    if (!(sectionRoot instanceof HTMLElement) || rootBindings.has(sectionRoot)) return false;

    const accountLinks = Array.from(sectionRoot.querySelectorAll(accountSelector));
    if (accountLinks.length === 0) return false;

    const closeMenus = (event) => {
      if (event.type === 'keydown' && event.key !== 'Escape') return;

      const openMenus = sectionRoot.querySelectorAll(`${accountMenuSelector}[open]`);

      openMenus.forEach((menu) => {
        if (event.type === 'mousedown' && menu.contains(event.target)) return;
        menu.open = false;

        if (event.type === 'keydown' && event.key === 'Escape') {
          menu.querySelector('summary')?.focus();
        }
      });
    };

    document.addEventListener('mousedown', closeMenus);
    document.addEventListener('keydown', closeMenus);
    rootBindings.set(sectionRoot, closeMenus);
    sectionRoot.dataset.minGuruSessionBound = 'true';

    accountLinks.forEach((accountLink) => {
      const endpoint = sessionEndpoint(accountLink);
      if (!endpoint) return;
      readSession(endpoint).then((session) => applySession(accountLink, session));
    });

    return true;
  };

  const cleanupRoot = (sectionRoot) => {
    if (!(sectionRoot instanceof HTMLElement)) return false;
    const closeMenus = rootBindings.get(sectionRoot);
    if (!closeMenus) return false;

    document.removeEventListener('mousedown', closeMenus);
    document.removeEventListener('keydown', closeMenus);
    delete sectionRoot.dataset.minGuruSessionBound;
    rootBindings.delete(sectionRoot);
    return true;
  };

  const initById = (rootId) => {
    if (!rootId) return false;
    return initRoot(document.getElementById(rootId));
  };

  document.addEventListener('shopify:section:load', (event) => initRoot(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupRoot(event.target));

  window[namespaceKey] = { cleanupRoot, initById, initRoot };

  document.querySelectorAll(markerSelector).forEach((marker) => {
    initById(marker.dataset.minGuruSessionRoot);
  });
})();
